<template>
  <DefaultPage>
    <FilterMain
      v-model="filterQuery"
      @input="debouncedSearch"
      @clear="clearInputSearch"
    />

    <div class="applications-view-wrapper">
      <div v-if="isLoadingApps" class="loading-wrapper">
        <BaseLoadingSpinner :with-overlay="false" :size="60" />
      </div>
      <template v-else>
        <section class="applications-wrapper">
          <SubletApplicationsLane
            title="Nekade"
            status="rejected"
            :applications="applicationsRejected"
            to-path="/andrahand/arkiv"
          ></SubletApplicationsLane>

          <SubletApplicationsLane
            title="Avslutade"
            status="closed"
            :applications="applicationsClosed"
            to-path="/andrahand/arkiv"
          ></SubletApplicationsLane>

          <SubletApplicationsLane
            title="Borttagna"
            status="removed"
            :applications="applicationsDeleted"
            to-path="/andrahand/arkiv"
          ></SubletApplicationsLane>
        </section>
      </template>
      <router-view />
    </div>
  </DefaultPage>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import debounce from 'lodash.debounce';

import statusTypes from '@/utils/statusTypes';
import SubletApplicationsLane from '@/components/SubletApplicationsLane.vue';
import FilterMain from '@/components/FilterMain.vue';
import BaseLoadingSpinner from '@/components/BaseLoadingSpinner.vue';
import DefaultPage from '@/components/DefaultPage.vue';

export default {
  name: 'SubletArchive',
  components: {
    SubletApplicationsLane,
    FilterMain,
    BaseLoadingSpinner,
    DefaultPage
  },
  beforeRouteUpdate(to) {
    this.maybeClearInputSearch(to.path);
  },
  beforeRouteLeave(to) {
    //Leaving to new route and unmounting
    this.maybeClearInputSearch(to.path);
  },
  data() {
    return {
      filterQuery: this.$store.state.applications.filter || ''
    };
  },
  computed: {
    ...mapGetters({
      filteredAhApps: 'applications/filteredAhApps'
    }),
    ...mapState('applications', ['isLoadingApps']),
    applicationsRejected() {
      if (!this.filteredAhApps) {
        return [];
      }
      return this.filteredAhApps.filter(
        x => x.landlordStatus === statusTypes.REJECTED
      );
    },
    applicationsClosed() {
      if (!this.filteredAhApps) {
        return [];
      }
      return this.filteredAhApps.filter(
        x => x.landlordStatus === statusTypes.CLOSED
      );
    },
    applicationsDeleted() {
      if (!this.filteredAhApps) {
        return [];
      }
      return this.filteredAhApps.filter(
        x =>
          x.landlordStatus === statusTypes.PENDING_REMOVE ||
          x.landlordStatus === statusTypes.REMOVED
      );
    }
  },

  async created() {
    this.debouncedSearch = debounce(this.search, 300);
    await this.fetchAhArchivedApps();
    // Ladda pending i bakgrunden så vi kan räkna matchningar i andra vyn
    this.fetchSubletApps();
    const firstAppId = this.filteredAhApps?.[0]?.id;
    if (firstAppId) {
      await this.fetchLandlordUsersWithUnassigned(firstAppId);
    }
  },

  methods: {
    ...mapActions({
      fetchAhArchivedApps: 'applications/fetchAhArchivedApps',
      fetchSubletApps: 'applications/fetchSubletApps',
      fetchLandlordUsersWithUnassigned:
        'applications/fetchLandlordUsersWithUnassigned'
    }),
    ...mapMutations({
      setFilter: 'applications/setFilter'
    }),
    maybeClearInputSearch(path) {
      // Behåll sökningen inom sublet-modulen (alla/arkiv/annonser)
      if (!path.includes('andrahand')) {
        this.clearInputSearch();
      }
    },
    clearInputSearch() {
      this.filterQuery = '';
      this.debouncedSearch.cancel();
      this.search('');
    },
    search(query) {
      this.setFilter(query);
    }
  }
};
</script>

<style scoped>
.applications-wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;
  max-width: 1080px;
}

.applications-view-wrapper {
  flex: 1;
  margin-left: 20px;
}

.loading-wrapper {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
}
</style>
